import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";

const Option = ({
  label,
  onPress,
  isSelected,
}: {
  label: string;
  onPress: () => void;
  isSelected: boolean;
}) => {
  return (
    <TouchableOpacity
      style={[styles.option, isSelected && styles.selectedOption]}
      onPress={onPress}
    >
      <Text style={styles.optionText}>{label}</Text>
    </TouchableOpacity>
  );
};

const OnboardSlide10 = () => {
  const [selectedOption, setSelectedOption] = useState<number>();
  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        Have you ever paid a security deposit that wasn’t refunded?
      </Text>
      <View style={styles.options}>
        <Option
          label="Rent deposits"
          onPress={() => setSelectedOption(0)}
          isSelected={selectedOption === 0}
        />
        <Option
          label="Utilities deposits"
          onPress={() => setSelectedOption(1)}
          isSelected={selectedOption === 1}
        />
        <Option
          label="Down payments"
          onPress={() => setSelectedOption(2)}
          isSelected={selectedOption === 2}
        />
      </View>
    </View>
  );
};

export default OnboardSlide10;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 16,
    paddingTop: 32,
  },
  title: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#EBFFEE",
  },
  options: {
    width: "100%",
    gap: 12,
  },
  option: {
    backgroundColor: "white",
    borderRadius: 12,
    height: 56,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#02685B",
  },
  selectedOption: {
    borderColor: "#CBEB6C",
    backgroundColor: "#E1EFE4",
  },
  optionText: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 18,
    color: "#161D14",
  },
});
